import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { GameLoading } from '../gameplay/game-loading';
import { GameLobby } from '../gameplay/game-lobby';
import { Gameplay } from '../gameplay/gameplay';
import { ShiritoriGameStore } from '@/game/core/game.store';
import { ShiritoriGameDb } from '@/firebase/shiritori-db';
import { GameState } from '@/game/core/game';
import { GameMessage } from '../gameplay/game-message';
import { LocalStorageKeyName, SetLocalStorage } from '@/util/local-storage';
import { Spectate } from '../gameplay/spectate';

export const GameView = observer(function () {
    const gameId = useParams<{ gameId: string }>().gameId || '';
    const gameStore = useMemo(() => {
        const gameDb = new ShiritoriGameDb(gameId);
        return new ShiritoriGameStore(gameDb);
    }, [gameId]);

    useEffect(() => {
        SetLocalStorage(LocalStorageKeyName.GameId, gameId);
    }, [gameId]);

    if (!gameStore) {
        return null;
    }

    function renderState() {
        switch (gameStore.state) {
            case GameState.NoSuchGame:
                return <GameMessage state={GameState.NoSuchGame} />;
            case GameState.Lobby:
                return <GameLobby game={gameStore} />;
            case GameState.Singleplayer:
            case GameState.Multiplayer:
            case GameState.Ended:
                return <Gameplay game={gameStore} />;
            case GameState.Spectate:
                return <Spectate game={gameStore} />
            default: return <GameLoading />;
        }
    }

    return (
        <div className="w-full h-full">
            {renderState()}
        </div>
    );
});
